import PageHeader from '../components/PageHeader.jsx';
import InsightsFeed from '../components/InsightsFeed.jsx';
import SnapPage from '../components/SnapPage.jsx';
import T from '../i18n/content.js';
import { useT } from '../i18n/LangContext.jsx';

export default function InsightsPage() {
  const t = useT();
  const S = T.insightsSec;
  return (
    <SnapPage>
      <PageHeader title={t(S.pageTitle)} lede={t(S.lede)} motif="motif-insights.png" motifSize="lg" lower />
      <InsightsFeed />
    </SnapPage>
  );
}
